<template>
    <div>
        <div class="col-12 mb-4 d-sm-flex justify-content-sm-between align-items-sm-baseline">
            <h4 class="pr-3">Invoices</h4>
            <DateRangeFilter
                    class="d-sm-flex"
                    :from-date="invoicesFromDate"
                    @on-from-input="getByDate({ from: $event })"
                    @on-to-input="getByDate({ to: $event })"
                    :to-date="invoicesToDate"
                    :disabled="loading"
            />
        </div>
        <AppTable
                :columns="columns"
                :rows="invoices"
                @on-row-click="viewInvoice"
                :query="query"
                :loading="loading"
                :total="total"
                @on-query-change="onQueryChange"
        />
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import DateRangeFilter from '../form/DateRangeFilter';
import AppTable from '../form/AppTable';

export default {
  components: {
    AppTable,
    DateRangeFilter,
  },
  computed: {
    ...mapGetters({
      invoices: 'invoices/invoices',
    }),
    ...mapState({
      query: (state) => state.invoices.query,
      total: (state) => state.invoices.totalInvoices,
      invoicesFromDate: (state) => state.invoices.dates.from,
      invoicesToDate: (state) => state.invoices.dates.to,
    }),
    columns() {
      return [
        {
          label: 'Date',
          field: 'issued_at',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'dd MMM yyyy',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Number',
          field: 'number',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Vessel',
          field: 'vessel.name',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Client company',
          field: 'client_company.name',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Status',
          field: 'status',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Total',
          field: 'total_amount',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Currency',
          field: 'currency_code',
          filterOptions: {
            enabled: true,
          },
        },
      ];
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    this.getInvoices();
  },
  methods: {
    getByDate(date) {
      this.$store.commit('invoices/dateProps', date);
      this.getInvoices();
    },
    getInvoices() {
      this.loading = true;

      this.$store.dispatch('invoices/getInvoices').finally(() => {
        this.loading = false;
      });
    },
    viewInvoice(event) {
      this.$router.push({
        name: 'invoice',
        params: { id: event.row.id },
      });
    },
    onQueryChange(props) {
      this.$store.commit('invoices/queryProps', props);
      this.getInvoices();
    },
  },
};
</script>
